module.exports = __webpack_public_path__ + "img/ltkfit-3x.dec7607.jpg";